import apis from '../../../api/index'
import Vue from 'vue'
const FormRichTextConfig = {
  // 类型
  componentType: 'FORM_RICH_TEXT',
  // 部件显示样式
  widgetConfig: {
    icon: 'form-rich-text',
    text: '富文本',
    optionTitle: true,
    description: '用于丰富的格式内容输入，支持文字、图片排版等'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12, // 3, 6, 9, 12
    height: 2,
    noBorder: true,
    render: {
      ide: 'FormRichText',
      edit: 'FormRichText',
      read: 'FormRichText'
    },
    lengthLimit: 200,
    label: '富文本',
    placeholder: '请输入',
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      }
    },
    customUploadImg: (file) => {
      const request = { ...apis.COMPONENT.FORM_UPLOAD_CONFIG_API }
      const formData = new FormData()
      formData.append('file', file, file.name)
      formData.append('uploadId', file.id)
      request.params = formData
      return new Promise((resolve, reject) => {
        Vue.prototype.$upload(request).asyncThen((resp) => {
          console.log(resp)
          let data = resp.data.tenantId
          const params = Vue.prototype.$base64.encode(JSON.stringify({
            xdaptenantid: data,
            xdaptoken: Vue.prototype.$axios.defaults.headers.xdaptoken
          }))
          const url = `${resp.data.url}&token=${params}`
          resolve(url)
        })
      })
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW'
  ]
}

export default FormRichTextConfig
